import ModuleRoutes from './modules/routes';
import { configureStore } from './store/configureStore';
import { PersistGate } from 'redux-persist/integration/react'
import { Routes, BrowserRouter, Route, useLocation } from "react-router-dom";
import ScrollToTop from "./modules/common/ScrollToTop";
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import DynamicHead from './components/DynamicHead';


import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/responsive.css';

const { store, persistor } = configureStore();

function App() {
  return (
    <>
      <Provider store={store}>
        <HelmetProvider>
          <BrowserRouter>
            <DynamicHead />
            <PersistGate loading={null} persistor={persistor}>
              <ScrollToTop>
                <Routes>
                  {ModuleRoutes()}
                </Routes>
              </ScrollToTop>
            </PersistGate>
          </BrowserRouter>
        </HelmetProvider>
      </Provider>
      

    </>
  );
}

export default App;